export function startLoader() {
    return { type: 'START_LOADER'}
}

export function stopLoader() {
    return { type: 'STOP_LOADER' }
}